import { QueryClient } from '@tanstack/react-query';

export const createSessionQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      // Keep dashboard data warm across tab switches and patient revisits so the
      // Summary widgets (Average Plate, Med Score, CGM, macronutrients…) render
      // instantly from cache instead of re-showing skeletons every visit.
      //
      // Every patient tab unmounts on navigation (PatientShell route-swaps them),
      // so the widgets' queries lose their observers each time you leave Summary.
      //   • staleTime — how long cached data is served before a background
      //     refetch. 30s was short enough that almost every remount refetched
      //     (flicker + network churn).
      //   • gcTime — how long an UNOBSERVED cache entry survives before it's
      //     dropped. It was unset, so React Query's 5-minute default applied:
      //     leave Summary for >5 min and the cache is gone → cold, skeleton
      //     reload on return. This was the main cause of the "reloads every
      //     visit" report.
      //
      // Clinician data doesn't change second-to-second, and mutations still call
      // invalidateQueries() to force an immediate refetch, so a few minutes of
      // staleness is safe. Per-query overrides (e.g. useDisaggregatedNutrition)
      // still win where a different window is wanted.
      staleTime: 5 * 60_000, // 5 minutes
      gcTime: 30 * 60_000, // 30 minutes
    },
  },
});

